<template>
  <div style="transition: 0.4s; z-index:1101;" class="w-11/12 lg:w-1/4 flex-1 bg-white rounded-xl space-y-6 p-6 tip-block" :class="`step${ nowStep }`">
    <p v-html="content"></p>
    <div v-if="nowStep != 10" class="tip-footer">
      <button
        class="hover:bg-gray-400 focus:outline-none rounded-xl px-4 py-1 mr-2 text-white transition duration-500 ease-in-out border-gray-500 border-2 bg-gray-500"
        @click="endListTeaching()"
      >
        結束教學
      </button>
      <button
        :style="{ opacity: nowStep === 1 ? 1 : 0 }"
        class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
        :disabled="nowStep !== 1"
        @click="closeTips()"
      >
        {{skipTipsText}}
      </button>
      <button 
        v-if="nowStep !== 90"
        class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400"
        @click="next()"
      >
        {{nextText}}
      </button>
      <button
        v-if="nowStep === 90"
        class="hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 text-blue-800 transition duration-500 ease-in-out border-yellow-400 border-2 bg-yellow-300"
        @click="closeTips()"
      >
        {{closeTipsText}}
      </button>
    </div>
  </div>
</template>

<script>
import * as contentData from '@/components/Mask/List.json';

export default {
  name: 'List',
  props: {
    nowStep: {
      type: Number,
      default: 7
    },
    selectLang: {
      type: String
    },
    topCode: {
      type: String
    },
  },
  data() {
    return {
      nextText: '下一步',
      finishText: '好的',
      skipTipsText: '跳過教學',
      closeTipsText: '好的'
    }
  },
  computed: {
    content() {
      const data = contentData.default.filter(e => e.step === this.nowStep);
      let message;
      if (data.length > 0) {
        message = data[0].content_zh_TW;
        if(this.selectLang == 'zh-CN'){
          this.nextText = '下一步';
          this.finishText = '好的';
          this.skipTipsText = '跳过教学';
          this.closeTipsText = '好的';

          message = data[0].content_zh_CN;
        }
        if(this.selectLang == 'en-US'){
          this.nextText = 'next';
          this.finishText = 'finish';
          this.skipTipsText = 'skip teaching';
          this.closeTipsText = 'OK';

          message = data[0].content_en_US;
        }
      } else {
        message = '';
      }
      return message;
    }
  },
  methods: {
    next() {
      this.$emit('nextStep');
      // this.nowStep = this.nowStep + 1;
    },
    closeTips() {
      this.$emit('closeTips');
    },
    endListTeaching(){
      //console.log('list endListTeaching');
      this.$emit('closeForTeaching', false);
    }
  }
};

</script>

<style lang="scss">

.tip-block {
  box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6);
  z-index: 100;
}
/* .step1 {
  position: absolute;
  top: 38vh;
  left: 50vw;
} */

.step7 {
  position: absolute;
  top: 15vh;
  left: 24vw;
}

.step8 {
  position: absolute;
  top: 15vh;
  right: 15vw;
}

.step9 {
  position: absolute;
  top: 15vh;
  left: 13vw;
}

.step90 {
  position: absolute;
  top: 15vh;
  left: 13vw;
}

.step10 {
  position: absolute;
  top: 12vh;
  left: 13vw;
}

@media (max-width: 1023px) {
  .step7, .step8, .step9, .step90, .step10 {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    top: 10vh;
    max-width: calc(100vw - 2rem);
  }
}

/*.step4 {
  position: absolute;
  top: 38vh;
  left: 46vw;
}

.step5 {
  position: absolute;
  top: 38vh;
  left: 56vw;
}

.step6 {
  position: absolute;
  top: 12vh;
  left: 10vw;
}*/

/*.step6 {
  position: absolute;
  top: 38vh;
  left: 34vw;
}*/

.tip-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

</style>
